module.exports = __webpack_public_path__ + "img/ics_o_reload_gray.5702c097.svg";